import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {withTranslation, WithTranslation} from "react-i18next";
import {UserState} from "../../store/user/types";
import {Svhc, ReachElement, ReachElementDbModel, ReachState, ReachPart} from "../../store/reach/types";
import {
    setEditingReachElements,
    setGeneralValidationsErrors,
    setReachElementsAndErrors
} from "../../store/reach/actions";
import {OverviewArticle} from "../../store/article/types";
import {compose} from "redux";
import {connect} from "react-redux";
import {AppState} from "../../store";
import axios from "axios";
import Paper from '@material-ui/core/Paper';
import {Button, createStyles, Theme, Toolbar, withStyles, WithStyles, LinearProgress} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Alert from "../../common/component/Alert";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import ReachTableRow from "./ReachTabeRow";
import Error from '@material-ui/icons/Error';
import Tooltip from "@material-ui/core/Tooltip";


type ElementsProps = RouteComponentProps & WithTranslation & WithStyles & {
    userState: UserState;
    reachState: ReachState;
    setEditingReachElements: typeof setEditingReachElements;
    setGeneralValidationsErrors: typeof setGeneralValidationsErrors;
    setReachElementsAndErrors: typeof setReachElementsAndErrors;
}

interface IElementsState {
    svhcs: Array<Svhc>;
    showError: boolean;
    errorMessage: string;
}

class ReachElements extends React.Component<ElementsProps, IElementsState> {

    state = {
        svhcs: new Array<Svhc>(),
        showError: false,
        errorMessage: '',
    }

    render() {
        const t = this.props.t;
        const classes = this.props.classes;
        return (
            <Paper style={{padding: "10px", margin: "25px"}}>
                <Toolbar>
                    <Typography color="inherit" variant="h6">{t('ReachElements.title')}</Typography>
                </Toolbar>
                <p className={classes.header}>
                    <span>{t('ReachElements.header1.1')}</span>
                    <span>&nbsp;<u>{t('ReachElements.header1.2')}</u></span>
                    <span>&nbsp;{t('ReachElements.header1.3')}</span>
                    <span>&nbsp;{t('ReachElements.header1.4')}</span>
                    <span>&nbsp;{t('ReachElements.header1.5')}</span>
                    <span>&nbsp;{t('ReachElements.header1.6')}</span>
                    <span>&nbsp;{t('ReachElements.header1.7')}</span>
                </p>
                <p className={classes.header}>
                    <span><u>{t('ReachElements.header2.1')}</u></span>
                    <span>&nbsp;{t('ReachElements.header2.2')}</span>
                    <span>&nbsp;{t('ReachElements.header2.3')}</span>
                    <span>&nbsp;{t('ReachElements.header2.4')}</span>
                    <span>&nbsp;{t('ReachElements.header2.5')}</span>
                    <span>&nbsp;<u>{t('ReachElements.header2.6')}</u></span>
                    <span>&nbsp;{t('ReachElements.header2.7')}</span>
                    <span>&nbsp;<u>{t('ReachElements.header2.8')}</u></span>
                    <span>&nbsp;{t('ReachElements.header2.9')}</span>
                    <span>&nbsp;{t('ReachElements.header2.10')}</span>
                    <span>&nbsp;{t('ReachElements.header2.11')}</span>
                </p>
                    <pre><span>&nbsp;{t('ReachElements.header2.12')}</span></pre>
                    <pre><span>&nbsp;{t('ReachElements.header2.13')}</span></pre>
                    <hr></hr>
                    <pre><span>&nbsp;{t('ReachElements.header2.14')}</span></pre>
                    <pre><span>&nbsp;{t('ReachElements.header2.15')}</span></pre>
                    <pre><span>&nbsp;{t('ReachElements.header2.16')}</span></pre>
                    <hr></hr>
                    <pre><span>&nbsp;{t('ReachElements.header2.17')}</span></pre>
                    <hr></hr>
                    <pre><span>&nbsp;{t('ReachElements.header2.18')}</span></pre>
                <p className={classes.header}>
                    <span>{t('ReachElements.echaLink.1')}</span>
                    <span>&nbsp;<a href="http://echa.europa.eu/web/guest/candidate-list-table"
                                   target="_blank">{t('ReachElements.echaLink.2')}</a></span>
                    <span>&nbsp;{t('ReachElements.echaLink.3')}</span>
                </p>
                <Divider/>
                {this.state.svhcs.length == 0 && <LinearProgress/>}
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell padding={'none'} className={classes.idCell}></TableCell>
                            <TableCell padding={'none'}
                                       className={classes.tableCell}>{t('ReachElements.name')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.tableCell}>{t('ReachElements.ec')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.tableCell}>{t('ReachElements.cas')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.tableCell}>{t('ReachElements.index')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.textFieldCell}>{t('ReachElements.weight')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.textFieldCell}>{t('ReachElements.packageWeight')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.textFieldCell}>{t('ReachElements.boxWeight')}</TableCell>
                            <TableCell padding={'none'}
                                       className={classes.tableCell}>{t('ReachElements.parts')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.svhcs.map((s: Svhc, i: number) => {
                            let e = this.getElementBySubstanceId(s.id) || {substanceId: s.id};
                            return (<ReachTableRow key={s.id} svhc={s} element={e} handleChange={this.handleChange}
                                                   editPart={this.editParts}/>);
                        })}
                    </TableBody>
                </Table>
                <Toolbar>
                    <div className={this.props.classes.toolbarButtonContainer}>
                        {this.props.reachState.generalValidationErrors.length > 0 &&
                        <Tooltip title={this.props.reachState.generalValidationErrors.map(e => t(e)).join(' ')}
                                 interactive>
                            <Error color="error"/>
                        </Tooltip>}
                        <Button variant="contained" color="primary" onClick={this.saveElements}
                                className={this.props.classes.button}
                                disabled={this.cannotSave()}>{t('common.save')}</Button>
                        <Button variant="contained" onClick={this.cancel}
                                className={this.props.classes.button}>{t('common.cancel')}</Button>
                    </div>
                </Toolbar>
                <Alert open={this.state.showError} message={this.state.errorMessage}
                       onClose={() => this.setState({showError: false})} type='error'/>
            </Paper>
        );
    }

    editParts = (substanceId: number) => {
        this.props.history.push({
            pathname: `${this.props.match.url}/parts`,
            state: {substanceId: substanceId}
        });
    }

    handleChange = (substanceId: number, propName: string) => (event: React.ChangeEvent) => {
        let elements = [...this.props.reachState.editingReachElements]; // clone elements array
        let elementIndex = elements.findIndex((e: ReachElement) => e.substanceId == substanceId);
        let element = elements[elementIndex];
        if (element) {
            element = Object.assign({}, element); // clone element
            elements[elementIndex] = element;
        } else {
            element = {substanceId: substanceId};
            elements.push(element);
        }

        let value = (event.target as HTMLInputElement).value;
        this.validateAndSetValue(element, propName, value);

        let generalValidationErrors = this.generalValidation(elements);

        this.props.setReachElementsAndErrors({elements: elements, errors: generalValidationErrors})
    };

    validateAndSetValue = (element: ReachElement, propName: string, value: string) => {
        element[propName] = undefined;
        let validation = [];
        if (value) {
            console.log("LUL "+propName)
            let numValue = Number(value);
            let validationText = 'ReachElements.validation.error';
            if(propName === 'productPackage'){
                validationText = 'ReachElements.validation.errorPackaging';
            }else if (propName === 'coveringBox'){
                validationText = 'ReachElements.validation.errorCoveringBox';
            }
            if (Number.isNaN(numValue)) {
                validation.push(validationText);
            } else {
                element[propName] = numValue;
                if (0.00001 > numValue || 100 < numValue) {
                    validation.push(validationText);
                }
                let svhc = this.getSvhcBySubstanceId(element.substanceId);
                if (svhc && svhc.threshold && numValue >= svhc.threshold) {
                    validation.push((this.props.i18n.language == 'de' ? svhc.messageD : svhc.messageE));
                }
            }
        }
        element[propName + 'Validation'] = validation;

        element.validation = [];
        if (element.product || element.productPackage || element.coveringBox) {
            if (!element.parts || element.parts.length == 0) {
                element.validation.push('ReachElements.validation.missingPartsError');
            }
        }
    }

    generalValidation = (elements: Array<ReachElement>): string[] => {
        let validation = [];
        let productSum = 0;
        let productPackageSum = 0;
        let coveringBoxSum = 0;
        elements.forEach(e => {
            productSum += e.product || 0;
            productPackageSum += e.productPackage || 0;
            coveringBoxSum += e.coveringBox || 0;
        });
        if (productSum > 100) {
            validation.push('ReachElements.validation.productSumError');
        }
        if (productPackageSum > 100) {
            validation.push('ReachElements.validation.productPackageSumError');
        }
        if (coveringBoxSum > 100) {
            validation.push('ReachElements.validation.coveringBoxSumError');
        }
        return validation;
    }

    cancel = () => {
        this.props.setReachElementsAndErrors({elements: [], errors: []});
        this.props.history.goBack();
    }

    componentWillMount() {
        let selectedArticles = this.props.location.state.articles;
        if (selectedArticles && selectedArticles.length == 1) {
            if (this.props.reachState.editingReachElements && this.props.reachState.editingReachElements.length > 0) {
                this.loadSvhcs();
            } else {
                this.loadElements(selectedArticles[0].icin);
                // load Svhcs after loading elements successfully
            }
        } else {
            this.loadSvhcs();
        }
    }

    getElementBySubstanceId(substanceId: number): ReachElement | undefined {
        return this.props.reachState.editingReachElements.find((e: ReachElement) => e.substanceId == substanceId);
    }

    getSvhcBySubstanceId(substanceId: number): Svhc | undefined {
        return this.state.svhcs.find((e: Svhc) => e.id == substanceId);
    }

    loadSvhcs() {
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/svhcs/required';
        axios.get(url)
            .then(res => {
                if (res.status == 200) {
                    if (res.data) {
                        console.log('Loaded ' + res.data.length + ' svhcs');
                        this.setState({svhcs: res.data});
                    } else {
                        console.log('Failed to get svhcs: no data!');
                    }
                } else {
                    console.log('Failed to get svhcs: server error ' + res.status + '!');
                }
            })
            .catch(err => {
                console.log('Failed to get svhcs: server error');
                console.log(err);
            })
    }

    loadElements(icin: string) {
        let supplierId = this.props.userState.user!.supplierId;
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/suppliers/' + supplierId + '/articles/' + icin + '/reachdeclarations/latest';
        axios.get(url)
            .then(res => {
                if (res.status == 200) {
                    if (res.data && res.data.elements) {
                        console.log('Loaded ' + res.data.elements.length + ' reach elements');
                        if(res.data.statusId == "3" || res.data.statusId == "8") {
                            res.data.elements.forEach((element : any) => {
                                element.product = null;
                                element.productPackage = null;
                                element.coveringBox = null;
                            });
                        }

                        this.props.setReachElementsAndErrors({elements: res.data.elements, errors: []});
                    } else {
                        console.log('Failed to get reach elements: no data!');
                    }
                    this.loadSvhcs();
                } else {
                    console.log('Failed to get reach elements: server error ' + res.status + '!');
                }
            })
            .catch(err => {
                console.log('Failed to get reach elements: server error');
                console.log(err);
            })
    }

    cannotSave = () => {
        return this.props.reachState.generalValidationErrors.length > 0
            || this.props.reachState.editingReachElements.some((e: ReachElement) => (
                (e.productValidation != undefined && e.productValidation.length > 0)
                || (e.productPackageValidation != undefined && e.productPackageValidation.length > 0)
                || (e.coveringBoxValidation != undefined && e.coveringBoxValidation.length > 0)
                || (e.validation != undefined && e.validation.length > 0)
            ));
    }

    saveElements = () => {
        let articleNumbers = this.props.location.state.articles.map((a: OverviewArticle) => a.icin);
        let elements = this.props.reachState.editingReachElements.map((e: ReachElement) => ({
            id: e.id,
            substanceId: e.substanceId,
            product: e.product,
            productPackage: e.productPackage,
            coveringBox: e.coveringBox,
            parts: e.parts
        } as ReachElementDbModel));
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/suppliers/' + this.props.userState.user!.supplierId
            + '/bulk/reachdeclarations';
        console.log(elements);
        axios.post(url, {articleNumbers: articleNumbers, elements: elements})
            .then(res => {
                if (res.status == 201) {
                    console.log('Saved reach elements with svhc of ' + articleNumbers);
                    this.props.setReachElementsAndErrors({elements: [], errors: []});
                    this.props.history.goBack();
                } else {
                    console.log('Failed to save reach elements with svhc: ' + res.status + '!');
                    this.setState({showError: true, errorMessage: this.props.t('Reach.declarationCreationFailed')});
                }
            })
            .catch(err => {
                console.log('Failed to save reach elements with svhc');
                console.log(err);
                this.setState({showError: true, errorMessage: this.props.t('Reach.declarationCreationFailed')});
            });
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    toolbarButtonContainer: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    button: {
        marginLeft: spacing.unit
    },
    tableCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit
    },
    idCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit,
        minWidth: 25
    },
    textFieldCell: {
        paddingLeft: spacing.unit,
        paddingRight: spacing.unit,
        minWidth: 100
    },
    header: {
        margin: spacing.unit
    },
    error: {
        color: palette.error.main
    }
});

const mapStateToProps = (state: AppState) => ({
    userState: state.user,
    reachState: state.reach
});

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation('common'),
    connect(mapStateToProps, {setEditingReachElements, setGeneralValidationsErrors, setReachElementsAndErrors})
)(ReachElements) as any;